import { Buffer } from 'buffer';

import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import { Provider } from 'react-redux';
import { store } from './app/store.js';
import App from './App';
import { clearSessionAndRedirectToLogin } from './utils/sessionAuth.js';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import './index.css';

window.Buffer = Buffer;

axios.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err.response?.status;
    const h = err.config?.headers || {};
    const auth = h.Authorization || h.authorization;
    const hadAuth = typeof auth === 'string' && /^Bearer\s/i.test(auth);
    const url = String(err.config?.url || '');
    const isLoginAttempt = url.includes('/api/users/login');
    if (status === 401 && hadAuth && !isLoginAttempt) {
      clearSessionAndRedirectToLogin();
    }
    return Promise.reject(err);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
